import type { RagResultToolDef } from '@kanbu/schema/contracts';

/**
 * During streaming, partial-json / failed Zod parse can leave `sources` as a
 * non-array. ToolProvider still passes the raw value through on schema errors.
 */
export function filterRagSources(
  sources: RagResultToolDef['sources'] | unknown,
): NonNullable<RagResultToolDef['sources']> {
  if (!Array.isArray(sources)) {
    return [];
  }

  const seenUrls = new Set<string>();

  return sources.filter(source => {
    if (!source?.url) return false;

    if (seenUrls.has(source.url)) return false;

    seenUrls.add(source.url);

    return true;
  });
}

/**
 * Structured-output chunks may temporarily set `content` to a non-string.
 */
export function ragDisplayContent(
  content: unknown,
  options: { isComplete: boolean; emptyFallback: string },
): string {
  const textContent = typeof content === 'string' ? content : '';

  if (textContent.trim() || !options.isComplete) {
    return textContent;
  }

  return options.emptyFallback;
}
